
import { Vue, Options } from "vue-class-component";
import Toaster from "../../helpers/Toaster";
import { useStore, ActionTypes } from "../../store";
import router from "../../router";

@Options({
  components: {},
  title: "User Logout",
})
export default class Logout extends Vue {
  private store;
  private toast;
  
  created() {
    this.toast = new Toaster();
    this.store = useStore();
  }

  mounted() {
    this.toast.showSuccess('Successfully Logged Out');
    this.store.dispatch(ActionTypes.AUTH_LOGOUT, "");
    router.push({ path: "/login" });
  }
}
